module.exports = __webpack_public_path__ + "media/images/login/link_btn_ov-3489a635342cd6e72536b4090c618bff.png";